(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/analytics-promotion/assets/javascripts/observeimpression.js') >= 0) return;  svs.modules.push('/components/components/analytics-promotion/assets/javascripts/observeimpression.js'); "use strict";

(function (window, document, svs, $) {
  'use strict';

  const visualElements = new Set();
  let intersectionObserver;
  svs.components = svs.components || {};
  svs.components.analytics = svs.components.analytics || {};
  const logger = svs.core.log.getLogger('components:analytics-promotion');
  const intersectionObserverOptions = {
    root: null,
    rootMargin: '0px',
    threshold: [0.4, 0.5]
  };
  const TIME_TO_IMPRESSION = 1000;

  function isArrayLike(obj) {
    return Array.isArray(obj) || Boolean(obj) === true && typeof obj === 'object' && typeof obj.length === 'number' && (obj.length === 0 || obj.length > 0 && obj.length - 1 in obj);
  }

  function mutationObserverCallback(mutationList) {
    mutationList.forEach(mutation => {
      if (mutation.type === 'childList' && isArrayLike(mutation.addedNodes)) {
        Array.prototype.forEach.call(mutation.addedNodes, node => {
          if (typeof node.hasAttribute === 'function' && node.hasAttribute('data-impression')) {
            intersectionObserver.observe(node);
          }

          if (typeof node.querySelectorAll === 'function') {
            const dataImpressionElements = node.querySelectorAll('[data-impression]');

            for (let i = 0; i < dataImpressionElements.length; i++) {
              intersectionObserver.observe(dataImpressionElements[i]);
            }
          }
        });
      }
    });
  }

  function setupMutationObserver() {
    if ('MutationObserver' in window) {
      const targetNode = document.querySelector('body');
      const mutationObserverOptions = {
        attributes: true,
        attributeFilter: ['data-impression'],
        childList: true,
        subtree: true
      };
      const mutationObserver = new MutationObserver(mutationObserverCallback);
      mutationObserver.observe(targetNode, mutationObserverOptions);
    }
  }

  function setupImpressionTracking() {
    if ('IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(handleIntersection, intersectionObserverOptions);

      try {
        const elementsToTrack = document.querySelectorAll('[data-impression]');

        for (let i = 0; i < elementsToTrack.length; i++) {
          intersectionObserver.observe(elementsToTrack[i]);
        }

        setupMutationObserver();
      } catch (e) {
        logger.warn("Unexpected error:".concat(e.message));
      }
    } else {
    }
  }

  function sendImpression(element) {
    const comp = {
      componentType: 'promo',
      componentID: element.dataset.track,
      componentName: element.dataset.track,
      componentPosition: element.dataset.areaName || 'unknownarea'
    };
    const evt = {
      event: 'promoImpression',
      component: [comp]
    };

    if (element.dataset.label) {
      evt.eventInfo = {
        eventName: element.dataset.label
      };
    }

    window.dataLayerPush(evt);
    window.eddl.eddlPush('promoView', {
      id: comp.componentID,
      name: comp.componentName,
      position: comp.componentPosition
    }); 

    const msg = new svs.core.log.Message(svs.core.log.MessageType.event);
    msg.eventCategory = 'Impression';
    msg.eventAction = "[".concat(comp.componentPosition, "]");
    msg.eventLabel = comp.componentName;
    msg.eventValue = 1;
    svs.core.log.track('svs.components.analytics', msg);
    intersectionObserver.unobserve(element);
    element.removeAttribute('data-impression');
  }

  function timeInViewport(element) {
    return setTimeout(() => {
      if (visualElements.has(element)) {
        sendImpression(element);
        visualElements.delete(element);
      }
    }, TIME_TO_IMPRESSION);
  }

  function handleIntersection(entries) {
    entries.forEach(entry => {
      const el = entry.target;

      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        visualElements.add(el);
        timeInViewport(el);
      } else {
        visualElements.delete(el);
      }
    });
  } 


  svs.components.analytics.testPromoImpression = function (element) {
    setupImpressionTracking();
    sendImpression(element);
  }; 


  $(() => {
    $(window).on('load', setupImpressionTracking);
  }); 

  $(window).on('unload', () => {
    $(window).off('load', setupImpressionTracking);
  });
})(window, window.document, svs, $);
 })(window);